import { NgModule } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@NgModule({
    imports: [
        ButtonModule,
        ToastModule,
        ConfirmDialogModule
    ],
    exports: [
        ButtonModule,
        ToastModule,
        ConfirmDialogModule
    ],
    providers: [
        MessageService,
        ConfirmationService
    ]
})
export class PrimeNgModule { }
